import QuizRoundedIcon from '@mui/icons-material/QuizRounded';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';

/**
 * The properties for the quiz intro card
 */
interface QuizIntroCardProps {
  /**
   * Start the quiz
   * @returns Void
   */
  startQuiz: () => void;
  /**
   * The title of the quiz
   */
  quizTitle: string;
  /**
   * The number of correctly answered questions the quiz requires in order to be considered complete
   */
  minimumAnswerCount: number;
}

/**
 * The quiz into card component is shown to the user to introduce a quiz and provide further instruction
 */
const QuizIntroCard = (props: QuizIntroCardProps) => {
  return (
    <Card
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        paddingX: '10px',
        paddingBottom: '20px',
      }}
    >
      <CardContent>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginBottom=".5em"
          gap="1.5em"
        >
          <Typography variant="h2" component="h2" align="center">
            {props.quizTitle}
          </Typography>
          <QuizRoundedIcon
            sx={{
              fontSize: 40,
            }}
            color="primary"
          />
        </Box>
        <Typography
          gutterBottom
          variant="body1"
          component="h2"
          align="center"
          sx={{ fontSize: '18px' }}
        >
          Carefully read the following questions. Once you get{' '}
          {props.minimumAnswerCount} questions correct, the quiz will be
          complete.
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          id="start-quiz-module"
          data-testid="start-quiz-button-id"
          variant="contained"
          color="primary"
          onClick={props.startQuiz}
        >
          Start Quiz
        </Button>
      </CardActions>
    </Card>
  );
};

export default QuizIntroCard;
